import React, { useState } from 'react';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '../ui/dialog';
import { Button } from '../ui/button';
import { Input } from '../ui/input';

/** Create a new price-book edition: currency (+ optional go-live date to schedule it ahead of time). */
export function NewEditionDialog({ open, onOpenChange, currentCurrency, onCreate, busy }) {
  const [currency, setCurrency] = useState(currentCurrency || 'AUD');
  const [name, setName] = useState('');
  const [effectiveFrom, setEffectiveFrom] = useState('');
  const sameCcy = currency.toUpperCase() === (currentCurrency || '').toUpperCase();
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[520px]" data-testid="new-edition-dialog">
        <DialogHeader>
          <DialogTitle className="text-base">New price-book edition</DialogTitle>
          <DialogDescription className="text-xs">
            A new edition of an existing currency (e.g. FY27 AUD) is cloned from the live edition and <b>must have a go-live date</b> — live quotes keep using the current edition until then.
            A new currency is cloned from the AUD book at the live FX rate as a starting point.
          </DialogDescription>
        </DialogHeader>
        <div className="grid grid-cols-3 gap-3 text-xs">
          <label>Currency<Input className="h-8 text-xs uppercase" maxLength={3} value={currency} onChange={(e) => setCurrency(e.target.value.toUpperCase())} data-testid="new-edition-currency" /></label>
          <label>Go-live date{sameCcy ? ' (required)' : ' (optional)'}<Input type="date" className="h-8 text-xs" value={effectiveFrom} onChange={(e) => setEffectiveFrom(e.target.value)} data-testid="new-edition-effective" /></label>
          <label>Name<Input className="h-8 text-xs" placeholder={sameCcy ? `FY27 ${currency}` : `FY26 SEP26 ${currency}`} value={name} onChange={(e) => setName(e.target.value)} data-testid="new-edition-name" /></label>
        </div>
        <div className="flex justify-end gap-2 pt-2">
          <Button variant="outline" size="sm" onClick={() => onOpenChange(false)} data-testid="new-edition-cancel">Cancel</Button>
          <Button size="sm" className="bg-[#0F2040] hover:bg-[#1a3260] text-white" disabled={busy || currency.length !== 3 || (sameCcy && !effectiveFrom)}
            onClick={() => onCreate({ currency, name: name || undefined, effective_from: effectiveFrom || undefined })} data-testid="new-edition-create">
            {effectiveFrom ? 'Schedule edition' : 'Create edition'}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
